import React, { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

// Componentes
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/sections/HeroSection';
import AboutSection from '../components/sections/AboutSection';
import ServicesSection from '../components/sections/ServicesSection';
import GallerySection from '../components/sections/GallerySection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import ContactSection from '../components/sections/ContactSection';
import StructuredData from '../components/seo/StructuredData'; // Importe o novo componente

const HomePage = () => {
  const [siteSettings, setSiteSettings] = useState(null); // Inicia como nulo
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const docRef = doc(db, "siteContent", "main");
    const unsubscribe = onSnapshot(docRef, (doc) => {
      if (doc.exists()) {
        setSiteSettings(doc.data());
      }
      setIsReady(true);
      
      const preloader = document.getElementById('preloader');
      if (preloader) {
          preloader.style.opacity = '0';
          setTimeout(() => {
              preloader.style.display = 'none';
          }, 500);
      }
    });
    return () => unsubscribe();
  }, []);

  // Atualiza título e meta description diretamente no <head>, com fallback estático
  useEffect(() => {
    document.title = siteSettings?.seoTitle || 'Hulk Cabeleireiro';

    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', siteSettings?.seoDescription || 'A melhor barbearia da sua cidade.');
  }, [siteSettings]);

  return (
    <>
      {/* Componente de Dados Estruturados para SEO Local */}
      <StructuredData settings={siteSettings} />

      <div style={{ visibility: isReady ? 'visible' : 'hidden' }} className="bg-background text-text">
        <Header />
        <main>
          <HeroSection settings={siteSettings} />
          <AboutSection settings={siteSettings} />
          <ServicesSection settings={siteSettings} />
          {siteSettings?.showGallery && <GallerySection settings={siteSettings} />}
          <TestimonialsSection settings={siteSettings} />
          <ContactSection settings={siteSettings} />
        </main>
        <Footer settings={siteSettings} />
      </div>
    </>
  );
};

export default HomePage;
